var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDrivingExperience = function SvgDrivingExperience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "drivingExperience_svg__a",
    d: "M0 0h19.85v13.5H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.075 5.25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "drivingExperience_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drivingExperience_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.933 8.93c-.197 0-.394-.021-.57-.087L3.337 6.695v4.668a11.217 11.217 0 0 0 13.17 0v-4.69l-6.004 2.148a1.75 1.75 0 0 1-.57.11m8.876-.68V5.862l-1.118.395v2.038a1 1 0 0 0-.372.767c0 .548.438.964.964.964a.973.973 0 0 0 .964-.964.93.93 0 0 0-.438-.81m.68-3.814L10.13 7.769a.543.543 0 0 1-.372 0L.378 4.438a.555.555 0 0 1 0-1.052L9.736.033a.543.543 0 0 1 .373 0l9.38 3.353c.482.175.482.877 0 1.052",
    mask: "url(#drivingExperience_svg__b)"
  })))));
};
export default SvgDrivingExperience;